import { render, staticRenderFns } from "./Birthday.vue?vue&type=template&id=07da5591&"
import script from "./Birthday.vue?vue&type=script&lang=js&"
export * from "./Birthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports